import { Controller } from 'stimulus';

class MemberController extends Controller {
  openModal(e) {
    e.preventDefault();
    const memberId = parseInt(e.target.getAttribute('data-member-id'), 10);

    this.fetchMember(memberId)
      .then((res) => {
        this.updateModalData(res);
      })
      .then(() => {
        $(this.modalTarget).modal('show');
      });
  }

  // eslint-disable-next-line class-methods-use-this
  fetchMember(id) {
    return $.ajax({
      url: window.app.api.member,
      data: {
        id,
      },
    });
  }

  updateModalData(data) {
    $(this.outputTarget).html(`
      <div class="position-relative z-index-2">
        <div class="row">
          <div class="col-md-5 mb-2 mb-md-0">
            <img
              data-src="${data.primary_portrait}"
              alt="${data.full_name}"
              class="lazyload img-fluid"
              loading="lazy"
            >
          </div>

          <div class="col-md-7">
            <div class="font-weight-semibold font-size-lg mb-2">
              ${data.full_name}
            </div>

            <table class="table modal__table my-0">
              <tr>
                <th width="150">
                  ${window.app.i18n.organization}
                </th>
                <td>
                  ${data.organization.name}
                </td>
              </tr>
              <tr>
                <th width="150">
                  ${window.app.i18n.industry}
                </th>
                <td>
                  ${data.organization.industry}
                </td>
              </tr>
            </table>

            <div class="font-weight-semibold font-size-lg mt-3">
              ${window.app.i18n.moreAboutTheOrganization}
            </div>

            <div class="font-size-md">
              ${data.organization.description}
            </div>
          </div>
        </div>

        <div class="row mt-3 mt-md-4">
          <div class="col-md-5 mb-2 mb-md-0">
            <div class="position-relative overflow-hidden ratio--16-9">
              <img
                data-src="${data.organization.logo}"
                alt="${data.organization.name}"
                class="modal__logo lazyload absolute-center"
                loading="lazy"
              >
            </div>
          </div>

            <div class="col-md-7">
              <div class="font-weight-semibold">
                ${window.app.i18n.visitingAddress}
              </div>

              <div class="mt-1 mb-2">
                ${data.organization.street} ${data.organization.house_number} <br>
                ${data.organization.postal_code} ${data.organization.city}
              </div>

              <table class="table modal__table my-0">
                <tr>
                  <th width="25">T.</th>
                  <td>
                    <a href="tel:${data.organization.phone_number_formatted}">
                      ${data.organization.phone_number}
                    </a>
                  </td>
                </tr>
                <tr>
                  <th width="25">E.</th>
                  <td>
                    <a href="mailto:${data.organization.email}">
                      ${data.organization.email}
                    </a>
                  </td>
                </tr>
                <tr>
                  <th width="25">W.</th>
                  <td>
                    <a href="${data.organization.website_url}" target="_blank" rel="nofollow noopener" class="decorate-links">
                      ${window.app.i18n.visiteWebsite}
                    </a>
                  </td>
                </tr>
              </table>
            </div>
        </div>
      </div>
    `);
  }
}

MemberController.targets = [
  'modal',
  'toggle',
  'output',
];

export default MemberController;
